<template>
  <div class="">
    <div class="flex md:block">
      <div
        v-for="(item, i) in adminSidebarMenus"
        :key="i"
        class="
          md:border-r md:border-gray-500
          w-full
          bg-[#FDF0E7]
          my-2
          md:my-0
        "
      >
        <div class="md:hidden mb-4"></div>
        <button
          @click="sidebar_to(item)"
          class="md:p-2 w-full flex justify-start"
        >
          <div class="md:flex items-center">
            <div class="mr-2">
              <v-icon> mdi-{{ item.icon }} </v-icon>
            </div>
            <div class="text-left text-[11pt] md:block hidden font-calibri">
              {{ item.title }}
            </div>
            <div v-if="none_bis_count && item.id == 1" :class="countClass">
              {{ none_bis_count }}
            </div>
            <div v-else-if="bis_count && item.id == 5" :class="countClass">
              {{ bis_count }}
            </div>
            <div v-else></div>
          </div>
        </button>
        <div class="md:hidden mb-4"></div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      countClass:
        "rounded-full w-[24px] h-[24px] ml-1 p-1 text-[10px] text-white flex items-center justify-center bg-red-500",
      bis_count: null,
      none_bis_count: null,
      customerCode: "",
      adminSidebarMenus: [
        {
          id: 1,
          title: "Open Tickets",
          name: "unassigned-tickets",
        },
        // {
        //   id: 2,
        //   title: "North",
        //   name: "north",
        // },
        // {
        //   id: 3,
        //   title: "South",
        //   name: "south",
        // },
        // {
        //   id: 4,
        //   title: "Vertical",
        //   name: "vertical",
        // },
        {
          id: 7,
          title: "Closed Tickets",
          name: "closed-tickets",
        },
        {
          id: 5,
          title: "Updated BIS",
          name: "updated-bis",
        },
        {
          id: 5.1,
          title: "Closed BIS",
          name: "closed-bis",
        },
        // {
        //   id: 6,
        //   title: "Appointment Request",
        //   name: "appointment-request",
        // },

        // {
        //   id: 8,
        //   title: "Assigned Tickets",
        //   name: "assigned-tickets",
        // },
        {
          id: 9,
          title: "Watch List",
          name: "watch-list",
        },
        // {
        //   id: 10,
        //   title: "Create Ticket",
        //   name: "create-ticket",
        // },
        {
          id: 11,
          title: "Email Archive",
          name: "email-archive",
        },
      ],
    };
  },
  mounted() {
    this.ticketCount();
  },
  methods: {
    ticketCount() {
      axios.get("/tickets/count").then((res) => {
        // this.bis_count = res.data.bis_count;
        // this.none_bis_count = res.data.none_bis_count;
        this.bis_count = res.data.bis_count;
        this.none_bis_count = res.data.none_bis_count;
      });
    },
    sidebar_to(item) {
      if (!this.$route.path.includes(item.name)) {
        this.$router.push({ name: item.name });
      }
    },
  },
};
</script>
